import React, { useState, useEffect } from 'react';
import { Button, Col, Input, Row, Label, ModalBody, Form, TabPane, TabContent, Spinner, FormFeedback, FormGroup, Card, CardBody, ListGroupItem, ListGroup, ModalHeader, ModalFooter, } from 'reactstrap';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import 'react-dual-listbox/lib/react-dual-listbox.css';
import DualListBox from "react-dual-listbox";

import * as reducerAssignation from '../../../../slices/assignationManagementResidueFinalDestination/reducer';
import * as reducerFinalDestination from '../../../../slices/finalDestination/reducer';
import { addNewFinalDestination, existsFinalDestination, updateFinalDestination } from '../../../../slices/finalDestination/thunk';
import { getFinalDestinationTypeList, getResidueCategoryList, getTreatmentDetailList, getTreatmentList } from '../../../../helpers/residue/backend_helper';
import { registerAssignationManagementResidueFinalDestination } from '../../../../slices/assignationManagementResidueFinalDestination/thunk';
import { useLoading } from '../../../../Context/LoadingContext';
import AssignationTreatmentResidueCategorySection from './AssignationTreatmentResidueCategorySection';
import OSelect from '../../../../Components/OElements/OSelect';
import SimpleBar from 'simplebar-react';
import validateRUT from '../../../../helpers/utils/validateRUT';


const FinalDestinationForm = ({ dataFinalDestination, isEdit, handleToggleModal, isOpen, activeTab, toggleTab, }) => {
	const { openLoading, closeLoading } = useLoading();
	const dispatch = useDispatch();

	const [selectedFinalDestinationType, setSelectedFinalDestinationType] = useState(null);
	const handleFinalDestinationTypeSelected = (optionSelected) => {
		setSelectedFinalDestinationType(optionSelected);
	};

	const iconsDualSelect = {
		moveLeft: <i className={`${Icons.chevronLeft}`} />,
		moveAllLeft: [
			<i key={0} className={`${Icons.chevronLeft}`} />,
			<i key={1} className={`${Icons.chevronLeft}`} />
		],
		moveRight: <i className={`${Icons.chevronRight}`} />,
		moveAllRight: [
			<i key={0} className={`${Icons.chevronRight}`} />,
			<i key={1} className={`${Icons.chevronRight}`} />
		],
		moveDown: <i className="ri-arrow-down-s-line" />,
		moveUp: <i className="ri-arrow-up-s-line" />,
		moveTop: <i className="ri-arrow-up-s-line" />,
		moveBottom: <i className="ri-arrow-down-s-line" />,
	}

	const [disabledCheck, setDisabledCheck] = useState(dataFinalDestination.disable);

	const selectorFinalDestination = createSelector(
		state => state.FinalDestinations,
		finalDestination => ({
			isAdding: finalDestination.isAdding,
			isAdded: finalDestination.isAdded,
			isUpdating: finalDestination.isUpdating,
			isUpdated: finalDestination.isUpdated,
			isLoadingList: finalDestination.isLoadingList,
			requireCloseModalFinalDestination: finalDestination.requireCloseModal,
			exists: finalDestination.exists
		})
	);
	const {
		isAdding,
		isAdded,
		isUpdating,
		isUpdated,
		isLoadingList,
		requireCloseModalFinalDestination,
		exists
	} = useSelector(selectorFinalDestination);

	const selectorAssignationManagementResidueFinalDestination = createSelector(
		state => state.AssignationManagementResidueFinalDestinations,
		assignationManagementResidueFinalDestination => ({
			isAddingAssignation: assignationManagementResidueFinalDestination.isAdding,
			isAddedAssignation: assignationManagementResidueFinalDestination.isAdded,
			requireCloseModalAssignationManagementResidueFinalDestination: assignationManagementResidueFinalDestination.requireCloseModal,
		})
	);
	const {
		isAddingAssignation,
		isAddedAssignation,
		requireCloseModalAssignationManagementResidueFinalDestination,
	} = useSelector(selectorAssignationManagementResidueFinalDestination);

	const [dataAssignationManagementResidueFinalDestination, setDataAssignationManagementResidueFinalDestination] = useState([]);

	// validation
	const validation = useFormik({
		// enableReinitialize: use this flag when initial values needs to be changed
		enableReinitialize: true,
		initialValues: {
			rut: dataFinalDestination.rut || '',
			code_sinader: dataFinalDestination.code_sinader || '',
			name: dataFinalDestination.name || '',
			address: dataFinalDestination.address || '',
			phone: dataFinalDestination.phone || '',
			disabled: dataFinalDestination.disabled,
			final_destination_type_id: dataFinalDestination.final_destination_type_id || ''
		},
		validationSchema: Yup.object({
			rut: Yup.string()
				.required('Campo requerido')
				.test('valid-rut', 'RUT inválido', value => validateRUT(value))
				.test({
					name: 'rut-exists-check',
					message: 'RUT ya existe',
					test: async function (value) {
						if (!isEdit && value) {
							const exists = await dispatch(existsFinalDestination(value));
							if (exists.payload.exists == true) {
								return this.createError({ message: 'RUT ya existe' });
							}
						}
						return true;
					}
				}),
			code_sinader: Yup.string().required('Campo requerido'),
			name: Yup.string().required('Campo requerido'),
			address: Yup.string().required('Campo requerido'),
			phone: Yup.number().typeError('Debe ser un número').required('Campo requerido'),
			final_destination_type_id: Yup.string().required('Campo requerido'),
		}),
		onSubmit: async (values) => {
			handleToggleModal();
			openLoading();
			console.log('datos asignaciones?: ', dataAssignationManagementResidueFinalDestination)
			try {
				if (isEdit) {
					const updatedFinalDestination = {
						_id: dataFinalDestination._id,
						final_destination_type_id: values.final_destination_type_id,
						rut: values.rut,
						code_sinader: values.code_sinader,
						name: values.name,
						address: values.address,
						phone: values.phone,
						disabled: dataFinalDestination.disabled,
						treatment_detail_ids: selectedDualTreatmentDetail,
						residue_category_ids: selectedDualResidueCategory
					};

					try {
						const response = await dispatch(updateFinalDestination(updatedFinalDestination)).unwrap();
						const { _id } = response;
						await dispatch(registerAssignationManagementResidueFinalDestination({
							final_destination_id: _id,
							assignations_management_residue_final_destination: dataAssignationManagementResidueFinalDestination
						}));
					} catch (error) {
						console.error(error);
					}
				} else {
					const newFinalDestination = {
						final_destination_type_id: values.final_destination_type_id,
						rut: values.rut,
						code_sinader: values.code_sinader,
						name: values.name,
						address: values.address,
						phone: values.phone,
						disabled: dataFinalDestination.disabled,
						treatment_detail_ids: selectedDualTreatmentDetail,
						residue_category_ids: selectedDualResidueCategory
					};
					try {
						const response = await dispatch(addNewFinalDestination(newFinalDestination)).unwrap();
						const { _id } = response;
						await dispatch(registerAssignationManagementResidueFinalDestination({
							final_destination_id: _id,
							assignations_management_residue_final_destination: dataAssignationManagementResidueFinalDestination
						}));
					} catch (error) {
						console.error(error);
					}
				}
			}
			finally {
				closeLoading();
			}
		},
	});

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModalFinalDestination && requireCloseModalAssignationManagementResidueFinalDestination) {
				console.log('requireCloseModals: ', requireCloseModalFinalDestination, requireCloseModalAssignationManagementResidueFinalDestination)
				dispatch(reducerFinalDestination.setRequireCloseModal(false));
				dispatch(reducerAssignation.setRequireCloseModal(false));
				handleToggleModal();
			}
		}
	}, [requireCloseModalFinalDestination, requireCloseModalAssignationManagementResidueFinalDestination]);

	const [residueCategoryList, setResidueCategoryList] = useState([]);
	const [treatmentDetailList, setTreatmentDetailList] = useState([]);
	const [residueCategorySelectedList, setResidueCategorySelectedList] = useState([]);
	const [treatmentDetailSelectedList, setTreatmentDetailSelectedList] = useState([]);
	const [optionsDualResidueCategory, setOptionsDualResidueCategory] = useState([]);
	const [optionsDualTreatmentDetail, setOptionsDualTreatmentDetail] = useState([]);
	const [selectedDualTreatmentDetail, setSelectedDualResidueTreatmentDetail] = useState([]);
	const [selectedDualResidueCategory, setSelectedDualResidueCategory] = useState([]);

	const getItemsResidueCategory = async () => {
		// setIsLoading(true);
		let response = null;

		try {
			response = await getResidueCategoryList();
			let itemsSelect = [];

			response.map(item => {
				itemsSelect.push({
					label: item.name + ' - ' + item.residue_type.name,
					value: item._id,
				})
			})
			setResidueCategoryList(response);
			setOptionsDualResidueCategory(itemsSelect);
			// setIsLoading(false);
		} catch (err) {
			switch (err.status) {
				default:
					console.log(err.message);
			}
			// setIsLoading(false);
		}
	};

	const getItemsTreatmentDetail = async () => {
		// setIsLoading(true);
		let response = null;

		try {
			response = await getTreatmentDetailList();
			let itemsSelect = [];

			response.map(item => {
				itemsSelect.push({
					label: item.name,
					value: item._id,
				})
			})
			setTreatmentDetailList(response);
			setOptionsDualTreatmentDetail(itemsSelect);
			// setIsLoading(false);
		} catch (err) {
			switch (err.status) {
				default:
					console.log(err.message);
			}
			// setIsLoading(false);
		}
	};

	function handleUpdateAssignations(dataAssignation) {
		let isAssignationFounded = false;
		let dataAssignations = dataAssignationManagementResidueFinalDestination;
		dataAssignations = dataAssignations.map((item) => {
			if (dataAssignation._id) {
				if (item._id === dataAssignation._id) {
					isAssignationFounded = true;
					return { ...item, ...dataAssignation };
				}
			}
			if (item.final_destination_id === dataAssignation.final_destination_id && item.residue_category_id === dataAssignation.residue_category_id) {
				isAssignationFounded = true;
				return { ...item, ...dataAssignation };
			}
			return item;
		})
		if (!isAssignationFounded) {
			dataAssignations.push(dataAssignation);
		}
		setDataAssignationManagementResidueFinalDestination(dataAssignations);
	}

	useEffect(() => {
		setResidueCategorySelectedList(selectedDualResidueCategory.map(item => {
			const residueCategory = residueCategoryList.find((residueCategory) => residueCategory._id == item)
			return {
				label: residueCategory?.name,
				value: residueCategory?._id,
				item: residueCategory
			}
		}).filter((item) => item != undefined));
	}, [selectedDualResidueCategory, residueCategoryList])


	// Update list treatment details available to multiselect treatment on assignation tab id 4 
	useEffect(() => {
		setTreatmentDetailSelectedList(selectedDualTreatmentDetail.map(item => {
			const treatmentDetail = treatmentDetailList.find((treatmentDetail) => treatmentDetail._id == item)
			if (treatmentDetail) {
				return {
					label: treatmentDetail.name,
					value: treatmentDetail._id,
					group: treatmentDetail.management.name + ' / ' + treatmentDetail.treatment.name,
					item: treatmentDetail
				}
			}

		}).filter((item) => item != undefined))
	}, [selectedDualTreatmentDetail, treatmentDetailList])

	useEffect(() => {
		getItemsResidueCategory();
		getItemsTreatmentDetail();

		if (dataFinalDestination) {
			// Load selected dual residue category
			if (dataFinalDestination?.residue_category_ids?.length)
				setSelectedDualResidueCategory(dataFinalDestination.residue_category_ids);
			if (dataFinalDestination?.treatment_detail_ids?.length)
				setSelectedDualResidueTreatmentDetail(dataFinalDestination.treatment_detail_ids);
		}
	}, [])

	return (
		<React.Fragment>
			<Form
				className='tablelist-form'
				onSubmit={e => {
					e.preventDefault();
					validation.handleSubmit();
					return false;
				}}
			>
				<ModalBody>
					<TabContent activeTab={activeTab}>
						<TabPane tabId='1'>
							<Row className='g-3'>
								<Col lg={2}>
									<Label for='rut' className='form-label'>
										RUT
									</Label>
									<Input
										name='rut'
										id='rut'
										className='form-control'
										placeholder='Ingrese una RUT'
										type='text'
										validate={{ required: { value: true } }}
										onChange={(e) => {
											const cleanValue = e.target.value.replace(/[.]/g, '');
											validation.setFieldValue('rut', cleanValue);
										}}
										onBlur={validation.handleBlur}
										value={validation.values.rut || ''}
										invalid={
											validation.touched.rut &&
												validation.errors.rut
												? true
												: false
										}
									/>
									{
										validation.touched.rut &&
											validation.errors.rut ? (
											<FormFeedback type='invalid'>
												{validation.errors.rut}
											</FormFeedback>
										) : null
									}
								</Col>
								<Col lg={2}>
									<Label for='code_sinader' className='form-label'>
										Código SINADER
									</Label>
									<Input
										name='code_sinader'
										id='code_sinader'
										className='form-control'
										placeholder='Ingrese un código'
										type='text'
										validate={{ required: { value: true } }}
										onChange={validation.handleChange}
										onBlur={validation.handleBlur}
										value={validation.values.code_sinader || ''}
										invalid={
											validation.touched.code_sinader &&
												validation.errors.code_sinader
												? true
												: false
										}
									/>
									{
										validation.touched.code_sinader &&
											validation.errors.code_sinader ? (
											<FormFeedback type='invalid'>
												{validation.errors.code_sinader}
											</FormFeedback>
										) : null
									}
								</Col>
								<Col lg={4}>
									<Label for='name' className='form-label'>
										Nombre
									</Label>
									<Input
										name='name'
										id='name'
										className='form-control'
										placeholder='Ingrese un nombre'
										type='text'
										validate={{ required: { value: true } }}
										onChange={validation.handleChange}
										onBlur={validation.handleBlur}
										value={validation.values.name || ''}
										invalid={
											validation.touched.name &&
												validation.errors.name
												? true
												: false
										}
									/>
									{
										validation.touched.name &&
											validation.errors.name ? (
											<FormFeedback type='invalid'>
												{validation.errors.name}
											</FormFeedback>
										) : null
									}
								</Col>
								<Col lg={4}>
									<OSelect
										key={dataFinalDestination?.final_destination_type_id || ''}
										label='Tipo'
										id='final_destination_type_id'
										name='final_destination_type_id'
										value={dataFinalDestination?.final_destination_type_id || ''}
										onSelect={handleFinalDestinationTypeSelected}
										requestApi={() => getFinalDestinationTypeList({})}
										disabled={false}
										validation={validation}
									/>
									{/* <GeneralSelect
										label='Tipo'
										value={{ _id: dataFinalDestination.final_destination_type_id } || ''}
										className={''}
										// invalid={validation.touched.x && validation.errors.x ? true : false}
										// error={validation.errors.x}
										onSelect={handleFinalDestinationTypeSelected}
										requestApi={getFinalDestinationTypeList}
										params={{}}
										disabled={false}
									/> */}
								</Col>
								<Col lg={8}>
									<Label for='address' className='form-label'>
										Dirección
									</Label>
									<Input
										name='address'
										id='address'
										className='form-control'
										placeholder='Ingrese una dirección'
										type='text'
										validate={{ required: { value: true } }}
										onChange={validation.handleChange}
										onBlur={validation.handleBlur}
										value={validation.values.address || ''}
										invalid={
											validation.touched.address &&
												validation.errors.address
												? true
												: false
										}
									/>
									{
										validation.touched.address &&
											validation.errors.address ? (
											<FormFeedback type='invalid'>
												{validation.errors.address}
											</FormFeedback>
										) : null
									}
								</Col>
								<Col lg={4}>
									<Label for='phone' className='form-label'>
										Fono
									</Label>
									<Input
										name='phone'
										id='phone'
										className='form-control'
										placeholder='Ingrese un fono'
										type='text'
										validate={{ required: { value: true } }}
										onChange={validation.handleChange}
										onBlur={validation.handleBlur}
										value={validation.values.phone || ''}
										invalid={
											validation.touched.phone &&
												validation.errors.phone
												? true
												: false
										}
									/>
									{validation.touched.phone && validation.errors.phone ? (
										<FormFeedback type='invalid'>
											{validation.errors.phone}
										</FormFeedback>
									) : null}
								</Col>
								{/* <div className='d-flex gap-3 pt-3'>
									<div>
										{isEdit && (
											<FormGroup className='d-flex align-items-center'>
												<Label className=''>
													<div className='d-flex'>
														<Input
															type="checkbox"
															checked={disabledCheck}
															onChange={(e) => setDisabledCheck(e.target.checked)}
														/>
														<div className='px-1'>
															¿Normativa inactiva?
														</div>
													</div>
												</Label>
												{validation.touched.disabled &&
													validation.errors.disabled ? (
													<FormFeedback type='invalid'>
														{validation.errors.disabled}
													</FormFeedback>
												) : null}
											</FormGroup>
										)}
									</div>
								</div> */}
							</Row>
						</TabPane>
						<TabPane tabId='2'>
							<div className="row">
								<div className="col-lg-12">
									<h5 className="fs-14 mb-1">Categorías de residuo</h5>
									<p className="text-muted">Selecciona las categorías de residuos a gestionar por el destino final</p>
									<Card className='border'>
										<CardBody>
											<SimpleBar style={{ maxHeight: "300px" }}>
												<DualListBox
													canFilter={true}
													filterPlaceholder='Buscar...'
													icons={iconsDualSelect}
													options={optionsDualResidueCategory}
													selected={selectedDualResidueCategory}
													onChange={(newValue) => setSelectedDualResidueCategory(newValue)}
												>
												</DualListBox>
											</SimpleBar>
										</CardBody>
									</Card>
								</div>
							</div>
						</TabPane>
						<TabPane tabId='3'>
							<div className="row">
								<div className="col-lg-12">
									<h5 className="fs-14 mb-1">Detalles de tratamientos</h5>
									<p className="text-muted">Selecciona los detalles de tratamientos a realizar por el destino final</p>
									<Card className='border'>
										<CardBody>
											<SimpleBar style={{ maxHeight: "300px" }}>
												<DualListBox
													canFilter={true}
													filterPlaceholder='Buscar...'
													icons={iconsDualSelect}
													options={optionsDualTreatmentDetail}
													selected={selectedDualTreatmentDetail}
													onChange={(newValue) => setSelectedDualResidueTreatmentDetail(newValue)}
												>
												</DualListBox>
											</SimpleBar>
										</CardBody>
									</Card>
								</div>
							</div>
						</TabPane>
						<TabPane tabId='4'>
							<div className="row">
								<div className="col-lg-12">
									<h5 className="fs-14 mb-1">Asignación de detalles de tratamientos a categorías de residuo</h5>
									<p className="text-muted">Por categoría de residuo vincule el/los tratamiento/s</p>
									<Card className='border'>
										<CardBody>
											<SimpleBar style={{ maxHeight: "400px" }}>
												{(residueCategorySelectedList.map((residueCategory) =>
													<AssignationTreatmentResidueCategorySection
														key={residueCategory._id}
														finalDestination={dataFinalDestination}
														residueCategory={residueCategory.item}
														treatmentDetails={treatmentDetailSelectedList}
														handleUpdateAssignations={handleUpdateAssignations}
													/>
												))}
											</SimpleBar>
										</CardBody>
									</Card>
								</div>

								{/* <div className="mt-4">
									<h5 className="fs-14 mb-1">Tipos de residuos</h5>
									<p className="text-muted">Selecciona los tipos de residuos a gestionar por el destino final</p>
									<DualListBox
										canFilter={true}
										filterPlaceholder='Buscar...'
										icons={iconsDualSelect}
										options={optionsDualResidueCategory}
										selected={selectedDualResidueCategory}
										onChange={(newValue) => setSelectedDualResidueCategory(newValue)}
									>
									</DualListBox>
								</div> */}

							</div>
						</TabPane>
					</TabContent>
				</ModalBody>
				<ModalFooter>
					<div className='hstack gap-2 justify-content-end'>
						<Button
							type='button'
							onClick={() => {
								handleToggleModal();
							}} className='btn-danger btn-label'>
							<i className="icon-x label-icon"></i>
							Cancelar
						</Button>
						<button
							type='submit'
							className='btn btn-label btn-primary'
							id='add-btn'
							disabled={isAdding || isUpdating || isAddingAssignation}
						>
							{isAdding || isUpdating || isAddingAssignation ? (
								<i className='label-icon'><Spinner size='sm' /></i>
							) : <i className="ri-save-3-line label-icon"></i>}
							{isEdit ? 'Editar' : 'Crear'} Destino Final
						</button>
					</div>
				</ModalFooter>
			</Form>
		</React.Fragment>
	);
};

export default FinalDestinationForm;
